import React from 'react';
import PropTypes from 'prop-types';
import makeStyles from '@mui/styles/makeStyles';
import { amber, green } from '@mui/material/colors';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import InfoIcon from '@mui/icons-material/Info';
import WarningIcon from '@mui/icons-material/Warning';
import SnackbarContent from '@mui/material/SnackbarContent';

const useStyles = makeStyles(theme => ({
  info: {
    backgroundColor: theme.palette.primary.main,
  },
  error: {
    backgroundColor: theme.palette.error.dark,
  },
  success: {
    backgroundColor: green[600],
  },
  warning: {
    backgroundColor: amber[700],
  },
  icon: {
    opacity: 0.9,
    marginRight: theme.spacing(1),
  },
  message: {
    display: 'flex',
    alignItems: 'center',
  },
}));

const iconVariants = {
  info: InfoIcon,
  error: ErrorIcon,
  success: CheckCircleIcon,
  warning: WarningIcon,
};

const Alert = ({ message, variant, ...props }) => {
  const classes = useStyles();
  const Icon = iconVariants[variant];

  return (
    <SnackbarContent
      className={classes[variant]}
      message={
        <span className={classes.message}>
          <Icon className={classes.icon} />
          {message}
        </span>
      }
      {...props}
    />
  );
};

Alert.defaultProps = {
  variant: 'info',
};

Alert.propTypes = {
  message: PropTypes.node.isRequired,
  variant: PropTypes.oneOf(['error', 'info', 'success', 'warning']),
};

export default Alert;
